import { Enum } from "@/commons/enums/Type";

export class DeviceEnum {
  static APPLIANCE = { value: 1, text: "appliance" };
  static CRAWLER = { value: 2, text: "crawler" };
  static PC = { value: 3, text: "pc" };
  static SMARTPHONE = { value: 4, text: "smartphone" };
  static UNKNOWN = { value: 5, text: "UNKNOWN" };

  static getByValue(value: number): Enum | undefined {
    if (value === DeviceEnum.APPLIANCE.value) {
      return DeviceEnum.APPLIANCE;
    }
    if (value === DeviceEnum.CRAWLER.value) {
      return DeviceEnum.CRAWLER;
    }
    if (value === DeviceEnum.PC.value) {
      return DeviceEnum.PC;
    }
    if (value === DeviceEnum.SMARTPHONE.value) {
      return DeviceEnum.SMARTPHONE;
    }
    if (value === DeviceEnum.UNKNOWN.value) {
      return DeviceEnum.UNKNOWN;
    }

    return undefined;
  }

  static getList(): Enum[] {
    return [
      DeviceEnum.APPLIANCE,
      DeviceEnum.CRAWLER,
      DeviceEnum.PC,
      DeviceEnum.SMARTPHONE,
      DeviceEnum.UNKNOWN,
    ];
  }
}
